export const getApiEndPoint = () =>
  'https://hocx8gfype.execute-api.us-east-1.amazonaws.com/prd';
